
function Title() {
    return (
        <h1 className="centerBox" style={{
                textAlign: "center",
                flexDirection: "column",
                fontSize: "clamp(20px, 8vw, 40px)",
                fontWeight: "300",
                lineHeight: "1.5",
                letterSpacing: "-0.5px",
            }}>
                <p>Lucky <span style={{ fontWeight: "900", }}>0-stream</span> Picker</p>
                <p style={{
                    fontSize: "18px",
                    padding: "2px 10px",
                    backgroundColor: "#f0f0f0",
                    color: "#141414",
                    fontWeight: "900",
                }}>NOT A PICKLE</p>
                <div className="centerBox" style={{
                    gap: "6px",
                    marginTop: "10px",
                }}>
                    <p style={{
                        fontSize: "20px",
                    }}>for</p>
                    <svg width="73" height="23" viewBox="0 0 174 54" fill="#00FFA3" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path d="M45.6671 9.40113L39.4132 44.5989H51.9506L58.1946 9.40113H45.6671Z"></path>
                        <path d="M62.5189 9.40113L60.8466 18.8121H76.125L56.265 44.5989H70.5143L81.33 30.5512L78.8363 44.5989H91.3639L94.4908 27.0049H84.0611L97.6177 9.40113H62.5189Z"></path>
                        <path d="M41.3428 9.40113H27.1034L34.3468 0H20.1074L6.55072 17.594H20.8001L0 44.5989H14.2493L25.065 30.5512L22.5713 44.5989H35.0988L38.2258 27.0049H27.7961L41.3428 9.40113Z"></path>
                        <path d="M101.942 9.40113L95.6881 44.5989H108.216L114.47 9.40113H101.942Z"></path>
                        <path d="M118.784 9.40113L117.121 18.8121H132.311L112.54 44.5989H126.779L137.466 30.6593L134.993 44.5989H147.53L150.657 27.0049H140.277L153.774 9.40113H118.784Z"></path>
                        <path d="M165.896 35.1879L170.477 9.40113H157.95L151.696 44.5989H159.8L158.128 54H170.665L174 35.1879H165.896Z"></path>
                    </svg>
                </div>
            </h1>
    );
}

export default Title;